import { Router } from '@angular/router';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SidebarService } from '../../service/sidebar.service';
import { Location } from '@angular/common';
import { Constants } from '../../constant';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit, AfterViewInit {

  constructor(private _router: Router,
    private sidebarService: SidebarService,
    private location: Location,
    private titleService: Title) {
    this.titleService.setTitle("Help - 2026 CAPE Contract Ratification");
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.showPhoneLink();
  }

  showPhoneLink() {
    if (window.innerWidth >= 700) {
      document.getElementById('callLink').innerHTML = '(626) 243-0340';
      document.getElementById('callLink2').innerHTML = '(626) 243-0340';
    }
  }

  returnToBallot() {
    this.location.back()
  }

}



// WEBPACK FOOTER //
// ./src/app/features/help/help.component.ts